import { useTranslation } from 'react-i18next';
import StyledOverviewSidebarTip from './__styled__/StyledOverviewSidebarTip';
import StyledOverviewSidebarBox from './__styled__/StyledOverviewSidebarBox';
import IconTipQuestionMark from '/shared/images/icons/bp-question-circled-black.svg';

interface Props {
  children?: React.ReactNode;
  $fullHeight?: boolean;
  $offsetTop?: string | null;
  $offsetRight?: string | null;
  $pinBottom?: boolean;
  as?: React.ElementType;
}

function OverviewSidebarTip({
  children,
  $fullHeight,
  $offsetTop = null,
  $offsetRight = null,
  $pinBottom = false,
  as = undefined,
}: Props) {
  const { t } = useTranslation();

  const $pinnedPosition = !!$offsetRight;
  return (
    <StyledOverviewSidebarBox $pinnedPosition={$pinnedPosition} $pinBottom={$pinBottom}>
      <StyledOverviewSidebarTip as={as} $fullHeight={$fullHeight} $offsetRight={$offsetRight} $offsetTop={$offsetTop}>
        <img src={IconTipQuestionMark} alt="Question mark icon" />
        <span>{t('shared:information')}</span>
        {children}
      </StyledOverviewSidebarTip>
    </StyledOverviewSidebarBox>
  );
}

export default OverviewSidebarTip;
